import React, { memo } from "react";
import { SiOpenai } from "react-icons/si";

import { NodeCard, NodeHandle, useNodeStyles } from "./nodeKit";

export default memo(({ data, isConnectable, id }) => {
  const classes = useNodeStyles();

  return (
    <NodeCard color="#3498db" icon={<SiOpenai />} title="OpenAI" id={id}>
      <NodeHandle type="target" isConnectable={isConnectable} />
      <div className={`${classes.slot} ${classes.ellipsis}`}>GPT AI Assistant</div>
      <NodeHandle type="source" id="a" isConnectable={isConnectable} />
    </NodeCard>
  );
});
